var pug = require("!./../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"wrapper\"\u003E\u003Ch1\u003Eプチプチ\u003C\u002Fh1\u003E\u003Cdiv class=\"content-wrapper\"\u003E\u003Cdiv class=\"puchi-wrapper\"\u003E\u003Cbutton class=\"button button--puchi js-reset\"\u003ERESET\u003C\u002Fbutton\u003E\u003Cdiv class=\"puchies\"\u003E";
for (var i = 0; i <= 49; i++)
{
pug_html = pug_html + "\u003Cdiv class=\"puchies__cell\"\u003E\u003Ci class=\"puchies__puchi\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


/*****************
 ** WEBPACK FOOTER
 ** ./app/posts/idea05.pug
 ** module id = 187
 ** module chunks = 0
 **/